var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#003EA6;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 441.2,
    cy: 440.1,
    r: 440.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.9,615.6v-351h138.5c26.6,0,49.3,5.1,68,15.2c18.7,10.1,33.1,24.1,42.9,42c9.9,17.9,14.8,38.5,14.8,61.8 c0,23.3-5,43.9-15.1,61.7c-10.1,17.8-24.6,31.7-43.6,41.7c-19,9.9-42,14.9-69,14.9h-88.3v-59.5h76.3c14.3,0,26.1-2.5,35.4-7.5 c9.3-5,16.3-11.9,20.9-20.7c4.6-8.9,6.9-19.1,6.9-30.6c0-11.7-2.3-21.9-6.9-30.6c-4.6-8.7-11.6-15.5-21-20.4 c-9.4-4.9-21.3-7.3-35.7-7.3h-50v290.4H137.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M665.9,378c-2.4-8.3-5.8-15.7-10.1-22.2c-4.3-6.5-9.6-11.9-15.9-16.5c-6.2-4.5-13.3-8-21.3-10.4 c-7.9-2.4-16.7-3.6-26.3-3.6c-17.9,0-33.7,4.5-47.2,13.4c-13.5,8.9-24.1,21.9-31.6,38.8c-7.5,17-11.3,37.7-11.3,62.1 c0,24.5,3.7,45.2,11.1,62.4c7.4,17.1,17.9,30.2,31.5,39.2c13.6,9,29.7,13.5,48.2,13.5c16.8,0,31.2-3,43.1-9 c11.9-6,21.1-14.5,27.4-25.5c6.3-11,9.5-23.9,9.5-38.9l15.1,2.2h-90.5v-55.9h146.9v44.2c0,30.9-6.5,57.3-19.5,79.4 s-31,39.1-53.8,51.1c-22.9,11.9-49,17.9-78.5,17.9c-32.9,0-61.8-7.3-86.7-21.9c-24.9-14.6-44.3-35.3-58.2-62.2 c-13.9-26.9-20.8-58.9-20.8-95.9c0-28.5,4.1-53.8,12.4-76.2c8.3-22.3,19.9-41.3,34.9-56.8c15-15.5,32.4-27.4,52.3-35.5 c19.9-8.1,41.4-12.2,64.6-12.2c19.9,0,38.4,2.9,55.5,8.7c17.1,5.8,32.4,13.9,45.7,24.4c13.3,10.5,24.2,23,32.7,37.5 c8.5,14.5,13.9,30.4,16.3,47.7H665.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPgIcon);
export default __webpack_public_path__ + "static/media/pg_icon.30d4855a518b9000b9b4074ff0bfa919.svg";
export { ForwardRef as ReactComponent };